<template>
  <div>
    <b-navbar toggleable="lg" type="light" variant="light">
      <b-container fluid>
        <b-navbar-brand>會議室預約系統</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item
              to="/makeBooking"
              :active="$route.path === '/makeBooking'"
            >
              預訂會議室
            </b-nav-item>
            <b-nav-item
              to="/manageBooking"
              :active="$route.path === '/manageBooking'"
            >
              管理預約
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
        <FBOInfo></FBOInfo>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
import FBOInfo from "./FBOInfo.vue";

export default {
  components: {
    FBOInfo,
  },
};
</script>
